import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './ui/SectionHeading';
import { modules } from '../data/modules';
import { totalVolumes } from '../data/offer';
export function ModulesSection() {
  return <section className="bg-navy py-16 sm:py-20" aria-labelledby="modules-title" data-id="element-114" data-mp="1iwcxjc03p0fu">
      <div className="mx-auto max-w-6xl px-4" data-id="element-115" data-mp="1dx9rbo8dwo6a">
        <SectionHeading id="modules-title" data-id="element-116" data-mp="1dudtdzwjdzhu">The {totalVolumes} <span className="text-gold" data-id="element-117" data-mp="2bj7e3xtsrfo1">Professional Volumes</span></SectionHeading>

        <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-118" data-mp="26kmdhxamutz2">
          {modules.map((module, index) => {
          const Icon = module.icon;
          return <motion.article key={module.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.15
          }} transition={{
            duration: 0.3,
            delay: index % 3 * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex flex-col overflow-hidden rounded-2xl border border-electric/50 bg-industrial shadow-glow" data-id="element-119" data-mp="21o5nsynsc7jv" data-mpi={index}>
                <div className="flex items-center justify-between gap-3 border-b border-electric/30 bg-navy/50 px-6 py-3" data-id="element-120" data-mp="1ntjzc4dw3xkl">
                  <p className="rounded-md bg-gold px-2.5 py-1 font-display text-sm font-extrabold uppercase tracking-wider text-navy" data-id="element-121" data-mp="1dw5k283pdetv">Volume {module.number}</p>
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-electric/60 bg-navy text-electric" data-id="element-122" data-mp="10369mkis2at6">
                    <Icon className="h-5 w-5" aria-hidden="true" data-id="element-123" data-mp="q6tfxmn8fwyf" />
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-6" data-id="element-124" data-mp="v54lhl6hvlau">
                  <h3 className="font-display text-2xl font-bold leading-tight text-silver" data-id="element-125" data-mp="v3bgeabj594y">{module.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-steel" data-id="element-126" data-mp="l7gsp0sg8nvb">{module.summary}</p>
                </div>
              </motion.article>;
        })}
        </div>
      </div>
    </section>;
}